import { createApp } from "vue";
//import './style.css'
import "./styles/car4u-tokens.css";
import App from "./App.vue";

// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import { createPinia } from 'pinia'
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import router from "./router";
import axios from "axios";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import "@mdi/font/css/materialdesignicons.css";
import 'flag-icons/css/flag-icons.min.css';

const myCustomLightTheme = {
  dark: true,
  colors: {
    background: "#FFFFFF",
    surface: "#FFFFFF",
    "surface-bright": "#FFFFFF",
    "surface-bright2": "#F3f1f1",
    "surface-light": "#e8e8e8",
    "surface-variant": "#606060",
    "surface-variant2": "#3e3a3a",
    "on-surface-variant": "#EEEEEE",
    "surface-black4u": "#333333",
    "surface-light4u": "#b2b2b2",
    "surface-light4u2": "#a5a5a5ff",
    "surface-brigh4u": "#d8d8d8",
    primary: "#069d25",
    "primary-darken-1": "#006D2E",
    secondary: "#0BCA22",
    "secondary-darken-1": "#0BCA22",
    error: "#B00020",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FB8C00",
    greencar: "#03AF24",
    graylight: "#F0F0F0",
    cardcar: "#e8e8e8",
    buttoncard: "#28a745",
    flagbutton: "#7D8085",
    iconbutton: "#D9D9D9",
    backblack: "#000",
    btnenviar: "#ac8244"
  },
  variables: {
    "border-color": "#000000",
    "border-opacity": 0.12,
    "high-emphasis-opacity": 0.87,
    "medium-emphasis-opacity": 0.6,
    "disabled-opacity": 0.38,
    "idle-opacity": 0.04,
    "hover-opacity": 0.04,
    "focus-opacity": 0.12,
    "selected-opacity": 0.08,
    "activated-opacity": 0.12,
    "pressed-opacity": 0.12,
    "dragged-opacity": 0.08,
    "theme-kbd": "#212529",
    "theme-on-kbd": "#FFFFFF",
    "theme-code": "#F5F5F5",
    "theme-on-code": "#000000",
  },
};

const options = {
  // You can set your default options here
};

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "myCustomLightTheme",
    themes: {
      myCustomLightTheme,
    },
  },
});

const pinia = createPinia()

axios.defaults.baseURL = "https://app01.grupomhautomotriz.com/seminuevosWS/api/";

createApp(App).use(router).use(vuetify).use(Toast, options).use(pinia).mount("#app");
